import { useState } from "react";
import { NavLink } from "react-router-dom";

function Navbar() {
    const [open, setOpen] = useState(false);

    const menuItems = [
        { name: "Home", path: "/" },
        { name: "About", path: "/about" },
        { name: "Hospital Facilities", path: "/medical-facilities" },
        { name: "Doctors", path: "/doctors" },
        { name: "Services", path: "/services" },
        { name: "Gallery", path: "/gallery" },
        { name: "Blogs", path: "/blogs" },
        { name: "Contact", path: "/contact" },
    ];

    return (
        <nav className="sticky top-0 z-50 bg-gradient-to-r from-blue-900 via-blue-700 to-indigo-700 shadow-xl">
            <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between">

                {/* ================= LOGO (IMAGE) ================= */}
                <NavLink to="/" className="flex items-center">
                    <img
                        src="/images/logo.jpg"
                        alt="Gavli Hospital Logo"
                        className="h-9 md:h-11 w-auto object-contain"
                    />
                </NavLink>


                {/* ================= DESKTOP MENU ================= */}
                <ul className="hidden md:flex items-center gap-10 text-[15px] font-medium">
                    {menuItems.map((item) => (
                        <li key={item.name}>
                            <NavLink
                                to={item.path}
                                end={item.path === "/"}
                                className={({ isActive }) =>
                                    `relative transition ${isActive
                                        ? "text-white font-semibold"
                                        : "text-blue-100 hover:text-white"
                                    }`
                                }
                            >
                                {({ isActive }) => (
                                    <>
                                        {item.name}
                                        <span
                                            className={`absolute left-0 -bottom-1 h-[2px] bg-white transition-all duration-300 ${isActive ? "w-full" : "w-0"
                                                }`}
                                        ></span>
                                    </>
                                )}
                            </NavLink>
                        </li>
                    ))}
                </ul>

                {/* ================= DESKTOP EMERGENCY ================= */}
                <a
                    href="tel:108"
                    className="hidden md:inline-flex items-center justify-center
          bg-gradient-to-r from-red-600 to-red-500
          text-white font-semibold px-7 py-2 rounded-full
          shadow-lg hover:shadow-red-600/60
          hover:scale-105 transition"
                >
                    Emergency 108
                </a>

                {/* ================= MOBILE TOGGLE ================= */}
                <button
                    className="md:hidden text-white text-3xl"
                    onClick={() => setOpen(!open)}
                >
                    ☰
                </button>
            </div>

            {/* ================= MOBILE MENU ================= */}
            {open && (
                <div className="md:hidden bg-gradient-to-b from-blue-900 to-blue-700 px-8 pb-6 space-y-5">
                    {menuItems.map((item) => (
                        <NavLink
                            key={item.name}
                            to={item.path}
                            end={item.path === "/"}
                            onClick={() => setOpen(false)}
                            className={({ isActive }) =>
                                `block text-lg transition ${isActive
                                    ? "text-white font-bold underline"
                                    : "text-blue-100 hover:text-white"
                                }`
                            }
                        >
                            {item.name}
                        </NavLink>
                    ))}

                    {/* Mobile Emergency */}
                    <a
                        href="tel:108"
                        className="block text-center bg-gradient-to-r from-red-600 to-red-500
            text-white font-bold py-3 rounded-full shadow-lg"
                    >
                        Emergency 108
                    </a>
                </div>
            )}
        </nav>
    );
}

export default Navbar;
